export default "ac686df7c3c6a97e.svg"